import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { local_network_set_avg_server_latency } from '@/state/network/local_network_set_avg_server_latency';
import { store } from '@/state/store';
import { service_socketio_client } from '../service_socketio_client';

export const on_received_pong = (latency: number) => {
  const timestamp = Date.now();

  // Store the latency with its timestamp
  service_socketio_client.RESPONSE_TIMES.push({ timestamp, latency });

  // delete old entries that are outside the time window
  service_socketio_client.RESPONSE_TIMES = service_socketio_client.RESPONSE_TIMES.filter(
    timeEntry => timestamp - timeEntry.timestamp <= CONSTANTS__client.PING_WINDOW_DURATION,
  );

  // Calculate the average latency
  const latency_total = service_socketio_client.RESPONSE_TIMES.reduce((sum, timeEntry) => sum + timeEntry.latency, 0);
  let avg_server_latency = service_socketio_client.RESPONSE_TIMES.length ? Math.round(latency_total / service_socketio_client.RESPONSE_TIMES.length) : 0;

  store.dispatch(local_network_set_avg_server_latency(avg_server_latency));
};
